'use strict';
const _ = require('underscore');
const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        action: null,
        work: null,
        relation: []
    },

    initialize: function() {
        this.listenTo(this.getWork(), 'change:deleted', this.delete);
    },

    getAction: function() {
        return this.get('action');
    },

    getWork: function() {
        return this.get('work');
    },

    isInput: function() {
        return _.contains(this.get('relation'), 'in');
    },

    isOutput: function() {
        return _.contains(this.get('relation'), 'out');
    },

    delete: function() {
        this.set('deleted', true);
    },

    isDeleted: function() {
        return this.get('deleted');
    }
});



// WEBPACK FOOTER //
// ./process/domain/entity/actionwork.js